
import { SMQuestionnaire } from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TAnswerBlock } from "../TAnswerBlocks";
import { TSelect } from "@/models/autocomplete";

@Component
export default class AnswerBlockAutocomplete extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: 0 }) readonly index!: number;
  @Prop({ type: Number, default: 0 }) readonly loopIndex!: number;

  input = "";

  options: TSelect[] = [];

  loading = true;

  async fetchOptions(val: string, isInitialFetch: boolean) {
    if (!val) return;

    try {
      const { data } = await this.axios.get(this.answerBlockData.url, {
        params: {
          q: encodeURIComponent(val),
        },
      });

      if (!data) return;

      this.options = data.items.map((v: any) => ({
        value: v.value,
        label: v.title,
      }));

      if (!isInitialFetch) return;

      this.input = this.options.find((option) => option.label === val)?.value ?? "";
    } catch ({ response }) {
      console.warn(response);
    } finally {
      this.loading = false;
    }
  }

  @Watch("input")
  updateAnswer() {
    if (!this.input) return;
    SMQuestionnaire.updateAnswer({
      index: this.index,
      value: this.input,
      required: this.answerBlockData.is_required,
      answer_block_id: this.answerBlockData.ID,
      answer_block_alias: this.answerBlockData.answer_block_alias,
      loop_index: this.loopIndex,
      condition: this.answerBlockData.condition,
    });
  }

  async created() {
    const answer = SMQuestionnaire.answers.find(
      (answer) =>
        answer.answer_block_id === this.answerBlockData.ID && this.loopIndex === answer.loop_index
    );

    if (this.index === null || !answer?.value) {
      this.loading = false;

      return;
    }

    await this.fetchOptions(answer.value, true);
  }
}
